export default __webpack_public_path__ + "static/media/ico_arrow.9e7e5dec.svg";